import { colors, font, maxWidth } from "../styles/theme";
import { services, NEUTRAL_SERVICE } from "../data/services";
import useLeadSubmit from "../lib/useLeadSubmit";
import usePhoneMask from "../lib/usePhoneMask";
import ConsentCheckbox from "./ConsentCheckbox";

// Большая форма заявки в подвале страницы услуг — на фоне montazh-electriki.jpg.
export default function LeadForm() {
  const { status, error, errors, submit, clearFieldError } = useLeadSubmit("Форма-CTA (подвал)");
  const phone = usePhoneMask();
  const field = {
    width: "100%",
    padding: "15px 16px",
    border: "1px solid #dde1e7",
    borderRadius: 11,
    fontFamily: font.body,
    fontSize: 15,
    background: "#fff",
    outline: "none",
  };

  return (
    <section style={{ position: "relative", overflow: "hidden", background: "#0c0c0c" }}>
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: "url('/hero-2.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(120deg,rgba(10,10,14,.84),rgba(10,10,14,.62))" }} />
      <div style={{ position: "relative", zIndex: 2, maxWidth, margin: "0 auto", padding: "70px 22px 80px" }}>
        <div style={{ maxWidth: 620, margin: "0 auto", textAlign: "center", color: "#fff" }}>
          <h2 style={{ fontFamily: font.display, fontWeight: 700, fontSize: "clamp(2rem,4vw,3rem)", textTransform: "uppercase", margin: 0 }}>
            Рассчитаем ваш проект
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.55, color: "#cfd3d9", margin: "16px 0 0" }}>
            Оставьте контакты — инженер свяжется с вами в течение 15 минут, ответит на вопросы и подготовит
            предварительный расчёт.
          </p>
        </div>

        {status === "success" ? (
          <div style={{ maxWidth: 760, margin: "34px auto 0", textAlign: "center" }}>
            <div style={{ fontFamily: font.display, fontWeight: 700, fontSize: 26, textTransform: "uppercase", color: "#fff" }}>
              Заявка отправлена!
            </div>
            <p style={{ margin: "12px 0 0", fontSize: 16, color: "#cfd3d9" }}>
              Спасибо! Инженер свяжется с вами в течение 15 минут.
            </p>
          </div>
        ) : (
        <form
          noValidate
          onSubmit={(e) => submit(e)}
          style={{
            maxWidth: 760,
            margin: "34px auto 0",
            background: "rgba(255,255,255,.97)",
            borderRadius: 18,
            boxShadow: "0 26px 70px rgba(0,0,0,.45)",
            padding: "28px 26px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
            gap: 14,
            alignItems: "start",
          }}
        >
          <div>
            <input
              name="name"
              style={{ ...field, borderColor: errors.name ? colors.red : "#dde1e7" }}
              placeholder="Ваше имя"
              onChange={() => clearFieldError("name")}
            />
            {errors.name && <div style={{ fontSize: 12.5, color: colors.red, marginTop: 5 }}>{errors.name}</div>}
          </div>
          <div>
            <input
              name="phone"
              style={{ ...field, borderColor: errors.phone ? colors.red : "#dde1e7" }}
              type="tel"
              inputMode="tel"
              placeholder="+7 (___) ___-__-__"
              value={phone.value}
              onChange={(e) => {
                phone.onChange(e);
                clearFieldError("phone");
              }}
              onFocus={phone.onFocus}
            />
            {errors.phone && <div style={{ fontSize: 12.5, color: colors.red, marginTop: 5 }}>{errors.phone}</div>}
          </div>
          <select name="service" defaultValue="" style={{ ...field, color: colors.text, cursor: "pointer" }}>
            <option value="">Выберите услугу</option>
            <option>{NEUTRAL_SERVICE}</option>
            {services.map((s) => (
              <option key={s.num}>{s.name}</option>
            ))}
          </select>
          {status === "error" && (
            <div style={{ gridColumn: "1 / -1", fontSize: 13.5, color: colors.red, textAlign: "center" }}>{error}</div>
          )}
          <ConsentCheckbox
            error={errors.consent}
            onChange={() => clearFieldError("consent")}
            style={{ gridColumn: "1 / -1" }}
          />
          <button
            type="submit"
            disabled={status === "sending"}
            style={{
              gridColumn: "1 / -1",
              background: colors.red,
              color: "#fff",
              border: "none",
              fontFamily: font.display,
              fontWeight: 600,
              fontSize: 16,
              letterSpacing: ".04em",
              textTransform: "uppercase",
              padding: 17,
              borderRadius: 11,
              cursor: status === "sending" ? "default" : "pointer",
              opacity: status === "sending" ? 0.7 : 1,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = colors.redDark)}
            onMouseLeave={(e) => (e.currentTarget.style.background = colors.red)}
          >
            {status === "sending" ? "Отправляем…" : "Отправить заявку"}
          </button>
        </form>
        )}
      </div>
    </section>
  );
}
